module.exports = __webpack_public_path__ + "static/client13-ae6a9d8e2864c71a9f7f91f5546457fd.png";